import React from 'react';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { Input } from 'semantic-ui-react';


export const DateData = ({
    field: { value, name },
    form: { setFieldValue },
    ...props
}) => {

    return (
        <DatePicker
            {...props}
            popperClassName="dateTime"
            dateFormat='dd/MM/yyyy'
            selected={(value && new Date(value)) || null}
            onChange={(data) => setFieldValue(name, data)}
            customInput={<Input className="dateWidth" icon={props.icon} iconPosition="left" />}
        />

    )
}
